import type { JSX } from 'react';
import { useMemo } from 'react';

import type { Props as CommentFormProps } from '../comment-form';
import type { Props as TextInputProps } from '../text-input';
import type { WithSlotProps } from '~/components/hocs';
import type { Comment } from '~/types/comment';
import { withSlot } from '~/components/hocs';
import { renderChild } from '~/components/layout/utils';
import { SlotsProvider } from '~/components/providers';
import { useTemplate } from '~/hooks';

export const NAME = 'CommentReplyForm';

export interface Props extends React.PropsWithChildren, WithSlotProps {
  className?: string;
  parentId: string;
  isLast?: boolean;
  onSubmit?: (comment: Comment) => void;
}

const CommentReplyFormComponent = (props: Props) => {
  const { parentId, isLast = false, onSubmit } = props;
  const template = useTemplate(NAME);
  const slots = useMemo(
    () => ({
      commentForm: {
        parentId,
        onSubmit,
      } satisfies Partial<CommentFormProps>,

      nameInput: {
        autoFocus: true,
        onChange: (e: React.ChangeEvent<HTMLInputElement>) => {
          if (e.target.value.trim().length > 22) return;
        },
      } satisfies Partial<TextInputProps>,

      'aside-divider': {
        className: isLast ? '' : 'aside-divider',
      } satisfies JSX.IntrinsicElements['div'],
    }),
    [parentId, isLast, onSubmit]
  );

  return <SlotsProvider slots={slots}>{renderChild(template)}</SlotsProvider>;
};

CommentReplyFormComponent.displayName = NAME;

export const CommentReplyForm = withSlot(CommentReplyFormComponent);
